import { Navigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { selectAuthentication } from "../../../redux/personaliseLessons/authenticationSlice";

export default function PersonalisePrivateRoute({ children }) {
  const token = useSelector(selectAuthentication)?.token;
  const location = useLocation();
  return token ? children : <Navigate to="/login" replace state={{ from: location }} />;
}
